import API from 'app/api';
import parseResponse from 'app/api/requests/parsers/response';
import { News } from 'app/api/entities/news';
import logError from 'app/error/logError';

const fetchLatestNews = params =>
  API.News.getNews(params).then(parseResponse).then(News).catch(logError);

export { fetchLatestNews };
